import Phaser from 'phaser';

export default class GridForeground extends Phaser.GameObjects.Container {
  constructor(scene, blockSize,gridWidth,gridHeight) {
    super(scene);

    const grid = this.scene.add.graphics();
    let i = 0;
    while (i < gridHeight) {
      let j = 0;
      while (j < gridWidth) {
        grid.lineStyle(blockSize / 20, '0x9E979E');
        grid.strokeRect(j * blockSize,i * blockSize,blockSize,blockSize);
        j++;
      }
      i++;
    }

    this.add(grid);
  }
}